export const utilityFilterSalesStatus =    [
    {
        name : '판매중',
        value : 0
    },
    {
        name : '판매예정',
        value : 1
    },
    {
        name : '판매완료',
        value : 2
    },
]

export const utilityFilterUseStatus =   [
    {
        name : '사용가능',
        value : 0
    },
    {
        name : '사용대기',
        value : 1
    },
    {
        name : '기한만료',
        value : 2,
    },
    {
        name : '사용완료',
        value : 3
    }
]
export const utilityUseStatus = {
    0: {name: '사용가능'},
    1: {name: '사용대기'},
    2: {name: '기한만료'}
};

export const utilitySellStatus = {
    0: {name: '판매중'},
    1: {name: '판매예정'},
    2: {name: '판매완료'}
};


export const utilityFilterSearchType =  [
    {
        name : '유틸리티 명',
        value : 'u_name'
    },
    {
        name : '컬렉션 명',
        value : 'c_title'
    },
    {
        name : '디렉터 닉네임',
        value : 'dir_nick'
    },
];
